var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
const SvgVideoPlay = (_ref, svgRef) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.445 -0.053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,48A24.006,24.006,0,0,1,14.658,1.886,24.006,24.006,0,0,1,33.342,46.114,23.848,23.848,0,0,1,24,48ZM21.572,16.462a3.056,3.056,0,0,0-2.089.843,2.96,2.96,0,0,0-.917,2.162v9.066a2.961,2.961,0,0,0,.917,2.162,3.055,3.055,0,0,0,2.089.843,2.99,2.99,0,0,0,1.59-.465l7.212-4.532a3,3,0,0,0,0-5.081l-7.212-4.532A2.986,2.986,0,0,0,21.572,16.462Z",
    transform: "translate(-0.445 0.053)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlay);
export default __webpack_public_path__ + "static/media/video-play.df8d883a99198472147e58cea64d8a6b.svg";
export { ForwardRef as ReactComponent };